import React, { Suspense, useEffect, useState } from 'react';
import './App.css';
import Home from './pages/Home';
import Footer from './components/Footer';
import { BrowserRouter, Link, Route, Routes } from 'react-router-dom';
import Sonda from './pages/Sonda';
import BOXi from './pages/BOXi';
import ATM from './pages/ATM';
import Contacts from './pages/Contacts';
import Header from './components/Header';
import Industria40 from './pages/Industria40';

function App() {
  const [isActive, setActive] = useState(false);

  useEffect(()=> {
    console.log('isActive ', isActive);
    
  },[isActive])

  return (
    <div className={isActive? "noScroll App" : "App"}>
      <Suspense fallback="loading">
      <Header isActive={isActive} setActive={(value) => setActive(value)}></Header>
        <Routes>
          <Route path="/" element={<Industria40 />} />
          <Route path="/home" element={<Home />} />
          <Route path="/crypto" element={<Sonda />} />
          <Route path="/BI" element={<Sonda />} />
          <Route path="/retail" element={<ATM />} />
          <Route path="/vending" element={<BOXi />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/industria40" element={<Industria40 />} />
        </Routes>
      <Footer></Footer>
    </Suspense>
    </div>
  );
}

export default App;
